<ng-container *transloco="let t;">
    <mat-toolbar>
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center" style="background-color: #ea7600;">
            <h1 fxFlex style="color: white;">{{t('layout.header.ChangePassword')}}</h1>
            <button style="color: white;" mat-icon-button class="close-button">
                <mat-icon mat-dialog-close (click)="onNoClick()">close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        <div mat-dialog-content fxLayout="column" class="padding-20">
            <div fxLayout="column wrap">
                <div fxFlex="100" fxFlex.sm="50" fxFlex.xs="100">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ t('changePassword.currentPassword') }}*</mat-label>
                        <input type="password" matInput formControlName="currentPassword">
                    </mat-form-field>
                </div>
                <div formGroupName="passwordGroup" fxLayout="column" fxFlex="100" fxFlex.sm="50" fxFlex.xs="100">
                    <div fxFlex="100" fxFlex.sm="50" fxFlex.xs="100">
                        <mat-form-field appearance="outline">
                            <mat-label>{{ t('changePassword.newPassword') }}*</mat-label>
                            <input type="password" matInput formControlName="newPassword">
                        </mat-form-field>
                        <mat-error
                            *ngIf="changePasswordForm.get('passwordGroup')?.get('newPassword')?.errors?.['pattern'] && changePasswordForm.get('passwordGroup')?.get('newPassword')?.['touched']">
                            {{ t('changePassword.Password Criteria')}}
                        </mat-error>
                    </div>
                    <div fxFlex="100" fxFlex.sm="50" fxFlex.xs="100">
                        <mat-form-field appearance="outline">
                            <mat-label>{{ t('changePassword.confirmPassword') }}*</mat-label>
                            <input type="password" matInput formControlName="confirmPassword">

                        </mat-form-field>
                        <mat-error
                            *ngIf="changePasswordForm.get('passwordGroup')?.errors?.['passwordMismatch'] && changePasswordForm.get('passwordGroup')?.touched">
                            {{ t('changePassword.Password Not Match')}}
                        </mat-error>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div fxLayout="row" class="dialog-actions">
        <button mat-flat-button color="primary" type="submit" (click)="onSubmit()"
            [disabled]="!changePasswordForm.valid">{{t('actions.Submit')}}</button>
        <button mat-stroked-button (click)="onNoClick()">{{t('actions.Cancel')}}</button>
    </div>
</ng-container>